import {Component, EventEmitter, Input, Output, OnInit} from "@angular/core";
import {DeviceAvdbSeries} from "../device-avdb-series";
import {DeviceAvdbType, DeviceAvdbTypeStatus} from "../device-avdb-type";
import {CoverageDetailComponent} from "../shared/coverage-detail.component";
import {DeviceAvdbInstalledIssue} from "../device-avdb-installed-issue";
import {IgnoreDatabaseComponent} from "../shared/ignore-database.component";
import {AvdbTypeRowStatus} from "./avdb-type-row-status";
import {DeviceService} from "../device.service";

@Component({
	selector: "avdb-region-row-v2",
	template: `
		<!-- Display installed region -->
		<div *ngIf="issueStatus && installedIssue && issueStatus.installedSeries && issueStatus.isIssueVisible"
			class="deviceproductrow_issuelist_horizontal_line">
			<div class="deviceproductrow_typeheading">
				<ng-container *ngIf="installedIssue">
					<button class="button-link"
							(click)="coverageModal.open(issueStatus.installedSeries.region)">
						{{issueStatus.installedSeries.region.name}}
					</button>
					— Cycle {{installedIssue.name}} <span
					*ngIf="installedIssue.versionNumber"> ({{installedIssue.versionNumber}})</span>
				</ng-container>
			</div>

			<div *ngIf="showJeppesenLogin" class="deviceproductrow_action">
				<a class="button button-primary" (click)="onJeppesenLoginButtonClicked()">
					Jeppesen Login
				</a>
			</div>
			<div class="deviceproductrow_status">
				<div class="{{issueStatus.statusColor}}">
					<i *ngIf="issueStatus.hasCheckIcon" class="fa fa-check-circle"></i>
					<i *ngIf="issueStatus.hasExclamationIcon" class="fa fa-exclamation-circle"></i>
					{{issueStatus.statusText}}
				</div>
				<div class="deviceproductrow_statussubtext"
					 *ngIf="issueStatus.statusSubtext">{{issueStatus.statusSubtext}}</div>
				<div class="deviceproductrow_statusremaining">
					<div *ngIf="issueStatus.expectedEndDate && issueStatus.expectedEndDate.isAfter()">Coverage until
						{{issueStatus.expectedEndDate | momentDate}}
					</div>
					<br>
					<button *ngIf="issueStatus.isIgnoreButtonVisible" class="button"
							(click)="ignoreDatabaseModal.open(deviceService, avdbType.deviceId, installedIssue.seriesID)">
						Ignore Database
					</button>
				</div>
			</div>
		</div>

		<!-- Display region that is not installed -->
		<div *ngIf="issueStatus && installableSeries && !installedIssue" class="deviceproductrow_issuelist_horizontal_line">
			<div class="deviceproductrow_typeheading">
				<ng-container>
					<button class="button-link"
							(click)="coverageModal.open(installableSeries.region)">
						{{installableSeries.region.name}}
					</button>
					— Cycle {{installableSeries.installableIssues[0].name}} <span
					*ngIf="installableSeries.installableIssues[0].versionNumber"> ({{installableSeries.installableIssues[0].versionNumber}}
					)</span>
				</ng-container>
			</div>
			<div class="deviceproductrow_status">
				<div class="{{issueStatus.statusColor}}">
					{{issueStatus.statusText}}
				</div>
				<ng-container *ngIf="installableSeries.expectedEndDate != null">
                    <div class="deviceproductrow_statusremaining">
                        Coverage until {{installableSeries.expectedEndDate | momentDate}}
                    </div>
                </ng-container>
			</div>
		</div>
	`,
})
export class AvdbRegionRowComponent implements OnInit{
	@Input() avdbType: DeviceAvdbType;
	@Input() coverageModal: CoverageDetailComponent;
	@Input() ignoreDatabaseModal: IgnoreDatabaseComponent;
	@Input() showJeppesenLogin: boolean;
	@Input() installedIssue: DeviceAvdbInstalledIssue;
	@Input() installableSeries: DeviceAvdbSeries;
	@Input() deviceService: DeviceService;
	@Output() jeppesenLoginButtonClicked = new EventEmitter();

	issueStatus: AvdbTypeRowStatus;

	ngOnInit() {
		if (this.installedIssue) {
			this.issueStatus = new AvdbTypeRowStatus(this.avdbType, this.installedIssue);
		} else {
			this.issueStatus = new AvdbTypeRowStatus(this.avdbType, null, DeviceAvdbTypeStatus.NOT_INSTALLED);
		}
	}

	onJeppesenLoginButtonClicked() {
		this.jeppesenLoginButtonClicked.emit()
	}
}
